import { commonFilter } from './filter';

export default {
  pageName: 'CommunityVideo',
  pageId: '20100',
  pagePath: '/opinion/Community/Video',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    GPT_Get_Btn: {
      buttonId: '2010001',
    },
    GPT_Confirm: {
      buttonId: '2010002',
    },
    ...commonFilter,
  },
};
